import React from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { ProblemSection } from "@/components/landing/ProblemSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { WorkflowSection } from "@/components/landing/WorkflowSection";
import { WorkspaceExperience } from "@/components/landing/WorkspaceExperience";
import { IntegrationSection } from "@/components/landing/IntegrationSection";
import { OutcomesSection } from "@/components/landing/OutcomesSection";
import { FaqSection } from "@/components/landing/FaqSection";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";

export default function FullContainerLanding() {
  return (
    <div className="min-h-screen bg-white font-sans text-ink antialiased" data-testid="fullcontainer-landing">
      <Navbar />
      <main>
        <Hero />
        <ProblemSection />
        <FeaturesSection />
        <WorkflowSection />
        <WorkspaceExperience />
        <IntegrationSection />
        <OutcomesSection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
